import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ActivePackageDetailsModal.styles';
import type { CurrentUserPackage } from '@/features/Profile/sections/Packages/api';
import { formatNumber } from '@/utils/helpers';
import { CheckIcon } from '@/components/UI/Icons/Icons';
import { ModalSheet } from '@/components/UI/ModalSheet';

type ActivePackageDetailsModalProps = {
  activePackage: CurrentUserPackage;
  isOpen: boolean;
  onClose: () => void;
  onRenew: () => void;
};

export function ActivePackageDetailsModal({
  activePackage,
  isOpen,
  onClose,
  onRenew,
}: ActivePackageDetailsModalProps) {
  const { t } = useTranslation();
  const hasDiscount = activePackage.discount > 0;

  return (
    <ModalSheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('pages.cabinet.package_information')}
      isInPortal
    >
      <S.DetailsCard $packageName={activePackage.name}>
        <S.Header>
          <S.Title>{activePackage.name}</S.Title>
        </S.Header>
        <S.Features>
          <S.Feature>
            <S.CheckIconBox>
              <CheckIcon />
            </S.CheckIconBox>
            {t('pages.cabinet.package_wallet_amount', {
              amount: formatNumber(activePackage.walletAmount, 0),
            })}
          </S.Feature>
          <S.Feature>
            <S.CheckIconBox>
              <CheckIcon />
            </S.CheckIconBox>
            {t('pages.cabinet.package_paid_ads_count', {
              adsCount: formatNumber(activePackage.paidAdsCount, 0),
            })}
          </S.Feature>
          {hasDiscount && (
            <S.Feature>
              <S.CheckIconBox>
                <CheckIcon />
              </S.CheckIconBox>
              {t('pages.cabinet.discount_for_services', {
                discount: activePackage.discount,
              })}
            </S.Feature>
          )}
        </S.Features>
      </S.DetailsCard>
      <S.Actions>
        <S.RenewButton onClick={onRenew}>
          {t('pages.cabinet.renew_package')}
        </S.RenewButton>
      </S.Actions>
    </ModalSheet>
  );
}
